import React from "react";
import { Trans, useTranslation } from "react-i18next";

/**
 * ההסבר על הקוד שמגיע בשיחה - וזו ההודעה שבלעדיה הלקוח תקוע.
 *
 * קוד שמגיע בשיחה אינו מוקרא ואינו נשלח בהודעה: המערכת מחייגת ממספר אקראי, מנתקת,
 * ו**המספר שמופיע על הצג הוא הקוד** - ארבע הספרות האחרונות שלו. לקוח שאינו יודע את
 * זה עונה לשיחה, שומע שתיקה, ואז ממתין למסרון שלעולם לא יגיע.
 *
 * ולכן זו לא שורת טקסט אלא הודעת אזהרה: היא נבדלת מיתר המסך, כדי שתיקרא לפני שדה
 * הקוד ולא אחריו.
 *
 * **מוצגת רק אחרי שהשיחה יצאה בפועל.** כל קורא מציב אותה מאחורי שני תנאים - שהשיטה
 * שנשלחה היא שיחה, ושהמסך כבר בשלב הקלדת הקוד - ולכן מעבר לשיטה אחרת, חזרה לשלב
 * הקודם או יציאה מהמסך מסירים אותה יחד עם השלב שהיא שייכת לו.
 *
 * `phone` הוא היעד שאליו יוצאת השיחה, והוא רשות: יש מסכים שכבר מציגים אותו בשורה
 * משלהם, ושם חזרה עליו רק מאריכה את ההודעה.
 */
const VoiceCallNotice = ({ phone = null }) => {
  const { t } = useTranslation();

  /*
   * `role="alert"` ולא `status`: זו הודעה שיש לפעול לפיה מיד, וקורא מסך צריך לשמוע
   * אותה ברגע שהיא נכנסת - כלומר בדיוק כשהשיחה יוצאת.
   */
  return (
    <div className="voice-call-notice" role="alert">
      {/*
        * משולש אזהרה, ולא שפופרת: מה שההודעה מבקשת מהלקוח הוא **לא** לעשות את הדבר
        * הטבעי - לא לענות לשיחה - וסמל שיחה היה מזמין בדיוק את זה.
        *
        * בתוך ה-SVG ולא קובץ תמונה: האייקונים שבתיקייה צבועים בערכה של המסך,
        * ו-`currentColor` צובע את זה בגוון האזהרה יחד עם שאר ההודעה.
        *
        * `aria-hidden` - הוא חוזר על מה שהכותרת אומרת.
        */}
      <svg
        className="voice-call-notice-icon"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
      <div className="voice-call-notice-text">
        <div className="voice-call-notice-title">
          {phone ? (
            <Trans
              i18nKey="We're calling <span>{{phone}}</span> right now"
              values={{ phone: phone }}
              /* היעד מבודד בכיווניות - מספר בתוך משפט עברי מוצג עם הקידומת בקצה הלא נכון. */
              components={{ span: <span className="ltr-span" /> }}
            />
          ) : (
            t("We're calling you right now")
          )}
        </div>
        <div className="voice-call-notice-line">
          {t("There is no need to answer the call")}
        </div>
        {/*
          * "מהו הקוד" מודגש, ולא כשורה שלישית בין שתיים שוות לה.
          *
          * זו התשובה לשאלה היחידה שהלקוח שואל ברגע הזה, והיא צריכה להימצא בסריקה
          * ולא בקריאה - כלומר גם על ידי מי שאינו קורא את כל ההודעה.
          */}
        <div className="voice-call-notice-line voice-call-notice-code">
          <Trans i18nKey="Your code is the <strong>last 4 digits</strong> of the number shown on your screen" />
        </div>
      </div>
    </div>
  );
};

export default VoiceCallNotice;
